/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-model',
    'pip-events',
    'window'
],
function(
    pip,
    pipEvents,
    window
){

	function initEventListeners(){

        pipEvents.appliance.bundleAvailabilityChecked.on(function(evtType, data) {
            if (data[0].processedResponse.isError) {
                pushAnalyticsErrorEvent({
                    type: 'system',
                    displayType: 'inline',
                    pageSection: 'pip',
                    message: "Sorry, an error occurred.",
                    code: data[0].rawResponse.deliveryAvailabilityResponse
                            && data[0].rawResponse.deliveryAvailabilityResponse.errorData
                            && data[0].rawResponse.deliveryAvailabilityResponse.errorData.errors
                            && data[0].rawResponse.deliveryAvailabilityResponse.errorData.errors.error
                            && data[0].rawResponse.deliveryAvailabilityResponse.errorData.errors.error.errorCode
                })
            } else {
                var bundledItems = data.map(function(element){
                    var bundledItem = {
                        productInfo: {
                            sku: element.processedResponse.sku,
                            isBundled: true,
                            eta: {
                                applStartDate: element.processedResponse.rawDeliveryDate || element.processedResponse.rawBackOrderedEstimatedDeliveryDate,
                                applEndDate: element.processedResponse.rawEndDeliveryDate
                            },
                            availabilityStatus: {
                                backOrder: element.processedResponse.isBackOrdered,
                                inStockAppl: element.processedResponse.isAvailable && !element.processedResponse.isOutOfStock
                            }
                        },
                        fulfillment: {
                            method: 'appl',
                            zip: element.processedResponse.zipCode
                        },
                    };
                    return bundledItem
                });
                pushAnalyticsEvent(bundledItems);
            }

        })


        pipEvents.appliance.bundleAvailabilityCheckedV3.on(function(evtType, data) {
            if (data[0].processedResponse.isError) {
                pushAnalyticsErrorEvent({
                    type: 'system',
                    displayType: 'inline',
                    pageSection: 'pip',
                    message: "Sorry, an error occurred.",
                    code: data[0].rawResponse.deliveryAvailabilityResponse
                            && data[0].rawResponse.deliveryAvailabilityResponse.errorData
                            && data[0].rawResponse.deliveryAvailabilityResponse.errorData.errors
                            && data[0].rawResponse.deliveryAvailabilityResponse.errorData.errors.error
                            && data[0].rawResponse.deliveryAvailabilityResponse.errorData.errors.error.errorCode
                })
            } else {
                var bundledItems = data[0].processedResponse.map(function(element){
                    var bundledItem = {
                        productInfo: {
                            sku: element.sku,
                            isBundled: true,
                            eta: {
                                applStartDate: element.rawDeliveryDate || element.rawBackOrderedEstimatedDeliveryDate,
                                applEndDate: element.rawEndDeliveryDate
                            },
                            availabilityStatus: {
                                backOrder: element.isBackOrdered,
                                inStockAppl: element.isAvailable && !element.isOutOfStock
                            }
                        },
                        fulfillment: {
                            method: 'appl',
                            zip: element.zipCode
                        },
                    };
                    return bundledItem
                });
                pushAnalyticsEvent(bundledItems);
            }

        })

        pipEvents.bundle.bundleDDOAnalytics.on(function(evtType, data) {
            var cartAdditionInfo = {
                displayPosition: 'n/a',
                productInfo: {
                    sku: data.bundleId,
                },
                recommendation: {
                    recommendationType: 'product bundle',
                    pageType: 'pip',
                    displayPosition: 'n/a',
                    anchorProductSku: data.primaryId,
                    strategy: 'n/a',
                    recommendationVersion: data.algorithmModel,
                    featureVersion: 'n/a'
                }
            };

            var items = [{
                productInfo: {
                    sku: data.primaryId,
                },
            }, cartAdditionInfo];

            if (data.accessories && data.accessories.length) {
                data.accessories.forEach(function(element){
                    items.push({
                        displayPosition: element.index+1,
                        productInfo: {
                            sku: element.productId,
                        },
                        recommendation: {
                            recommendationType: 'product bundle',
                            pageType: 'pip',
                            anchorProductSku: data.primaryId,
                            strategy: 'n/a',
                            recommendationVersion: data.algorithmModel,
                            featureVersion: 'n/a',
                            interval: 'n/a'
                        }
                    });
                });
            }

            pushAnalyticsEvent(items, true);
        })
	}

    function pushAnalyticsEvent(item, stash) {
        var analyticsObj;
        if (stash) {
            analyticsObj = {
                stash: {
                    item: Array.isArray(item) ? item : [item],
                    component: 'product pod',
                    pageType: 'pip',
                    section: 'product bundle',
                    sharedSection: 'n/a',
                    target: 'analytics',
                    interval: 'n/a'
                },
                category: {
                    primaryCategory: 'stash'
                },
                eventInfo: {
                    eventName: 'cart addition info',
                },
                eventMode: 'stash'
            };
        } else {
            analyticsObj ={
                item: Array.isArray(item) ? item : [item],
                category: {
                    primaryCategory: 'button submission'
                },
                eventInfo: {
                    eventName: 'check fulfillment availability',
                }
            };
        }

		if (pip.debugMode) console.log('DDO Appliance Event', analyticsObj);

		if(window.digitalData && window.digitalData.event) window.digitalData.event.push(analyticsObj);
    }

	function pushAnalyticsErrorEvent(error){
		var analyticsObj ={
			category:{
				primaryCategory: 'error'
			},
			eventInfo: {
				eventName: 'post page error',
				error: [error]
			}
		};

		if (pip.debugMode) console.log('DDO Appliance Error Event', analyticsObj);

		if(window.digitalData && window.digitalData.event) window.digitalData.event.push(analyticsObj);

	}

	return {
		init: function(){
			initEventListeners();
		}
	}

});

}.call(window));